<template>
  <div>
    <div
      v-if="vacancy"
      :class="{
        'vacancies-item-bordered' : boxBordered,
        'cursor-pointer' : linkItem,
        'with-hover' : !showContextDetails,
      }"
      class="vacancies-item vacancies-item-bordered text-primary m-b-100  p-b-100"
      @click="redirectToDetails"
    >
      <VacancyHeading
        :title="vacancy && vacancy.title"
        :date="vacancy && vacancy.date"
      />
      <VacancyContext
        :vacancy="vacancy"
        :show-context-details="showContextDetails"
      />
    </div>
    <h3
      v-else
      class="font-weight-bold text-center main-blue"
    >
      Page not found
    </h3>
    <ScrollToTop />
  </div>
</template>

<script>
import VacancyHeading from '@/components/Vacancies/VacancyHeading';
import VacancyContext from '@/components/Vacancies/VacancyContext';
import { R_VACANCIES_DETAILS } from '@/router/routes';
import ScrollToTop from '@/components/ScrollToTop';

export default {
  name: 'VacanciesItem',
  components: { ScrollToTop, VacancyContext, VacancyHeading },
  props: {
    vacancy: {
      type: Object,
      default: () => {},
    },
    showContextDetails: {
      type: Boolean,
      default: false,
    },
    boxBordered: {
      type: Boolean,
      default: false,
    },
    linkItem: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    redirectToDetails() {
      if (this.linkItem) {
        this.$router.push({
          name: R_VACANCIES_DETAILS,
          query: {
            id: this.vacancy.id,
          },
        });
      }
    },
  },
};
</script>
